/// <reference path="../../../../../rcwebmodels/reeferformatter.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/rcdstatus.cs.d.ts" />

import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as RcdStatusState from '../../store/RcdStatus';
import * as UserDetailState from '../../store/UserDetails';
import { AgGridReact } from 'ag-grid-react';
import Formatters from '../../actions/Formatters';
import { CellRenderer } from '../../actions/CellRenderer';
import ReeferFormatter from '../../actions/ReeferFormatter';
import { ReeferCellRenderer } from '../../actions/ReeferCellRenderer';
import GensetFormatter from '../../actions/GensetFormatter';
import { GensetCellRender } from '../../actions/GensetCellRender';
import $ from 'jquery';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { GridToolBarControl } from '../sharedcomponents/GridToolBarControl';
// pull in the ag-grid styles we're interested in
import './../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import './../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
import { RcdAdvanceSearch } from '../childcomponents/RcdAdvanceSearch';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import CheckboxTree from 'react-checkbox-tree';
import { SendEmailControl } from './../sharedcomponents/SendEmailControl';
import { DevicePingControlForM2C } from './../sharedcomponents/ForwardCommands/DevicePingControlForM2C';
import { DevicePingControl } from './../sharedcomponents/ForwardCommands/DevicePingControl';
import { DeviceChangeReportingInterval } from './../sharedcomponents/ForwardCommands/DeviceChangeReportingInterval';
import { DeviceAssignPANID } from './../sharedcomponents/ForwardCommands/DeviceAssignPANID';
import { AutoConfiguration } from './../sharedcomponents/ForwardCommands/AutoConfiguration';
import { DeviceUnassignFromCustomer } from '../childcomponents/DeviceUnassignFromCustomer';
import { DeviceResetDeviceStatus } from './../sharedcomponents/ForwardCommands/DeviceResetDeviceStatus';
import { DeviceHardResetDeviceStatus } from './../sharedcomponents/ForwardCommands/DeviceResetDeviceStatus';
import { GetAssetId } from './../sharedcomponents/ForwardCommands/GetAssetId';
import { EditAsset } from './../childcomponents/EditAsset';
import { RCUtils } from './../../RCUtils';
import ExportAction from '../../actions/ExportAction'
import UserRights from '../../actions/UserRights';
import * as Exceljs from '../../actions/ExportToExcel.js';
import * as Autosuggest from 'react-autosuggest';
var Excel = Exceljs.default;
var Config: any = require('../../Config.json');


class customerSearchlst {
    customerID: any[] = [];
    customerName: any[] = [];
}

//var rcdColumns;
var rcdStatus;
var statusFilters;
var selectedRowDataIds;
var selectedRowsRcdData;
var selectedRowData;
var SelectedRcds = "";
var lastCheckedNodes = [];
var customerTypeCd;
var custId;
var coppiedData;
var coppiedDataWithHeader;
var EnableLynxCommands: boolean;
var EnableCT35ML5Commands: boolean; //RCNG-3425
var customerlst = new customerSearchlst();

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

class ExportFields {
    ExportData: string;
}

interface RcdStatusSearchState {
    showAssignToCustomerComponent: boolean;
    showEmailComponent: boolean;
    isAssigned: boolean;
    assignedRcdCount: number;
    rcdcustomerUI: RCDCustomerIdUI[];
    checked: any;
    TreeNodes: treeNodes[];
    AssignedStatus: string;
    SelectedCustomer: SelectedCustomer;
    isLoading: boolean;
    modelTitle: string;
    popUpHtml: any;
    checkedNode: boolean;
    pageSize: any;
    gridApiParams: any;
    exportFields: ExportFields;
    VCCheckBoxInfo: VCCheckBoxData;
    rowGroupPanelShow: string;
    groupDefaultExpanded: number;
    autoGroupColumnDef: any;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
    customerIdvalue: any,
    customerSuggestions: any[],
    targetId: string,
    selectedTreeNodes: treeNodes[];
    showEditAssetWindow: boolean,
    rcdColumns: any[];  
}

interface treeNodes {
    label: string;
    value: string;
    disabled: string;
    icon: string;
}

class RCDCustomerIdUI {
    RCDMasterID: number;
    RCDID: string;
    CustomerID: number;
}

class SelectedCustomer {
    SelectedRcdIDs: string;
    CustomerID: number;
}

// At runtime, Redux will merge together...
type RcsStatusProps =
    UserDetailState.UserState
    & RcdStatusState.RcdSearchState        // ... state we've requested from the Redux store
    & typeof RcdStatusState.actionCreators      // ... plus action creators we've requested
    & RouteComponentProps<{}>; // ... plus incoming routing parameters
var self;

class RcdStatus extends React.Component<RcsStatusProps, RcdStatusSearchState> {
    myCustomerRequest: any;
    constructor(props: any) {
        super(props);
        this.props.requestRefApplicationParams();
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        customerTypeCd = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd;//this.props.loggedInUserData.User.Customer.CustomerTypeCd;
        custId = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerId;//this.props.loggedInUserData.User.Customer.CustomerId;
        var Columns = this.createColumnDefs();
        var filterSet = new SelectedCustomer();
        var exportData = new ExportFields();
        this.state = {
            isLoading: true,
            showAssignToCustomerComponent: false,
            showEmailComponent: false,
            isAssigned: false,
            assignedRcdCount: 0,
            rcdcustomerUI: [],
            checked: [],
            TreeNodes: [],
            AssignedStatus: '',
            SelectedCustomer: filterSet,
            modelTitle: '',
            popUpHtml: '',
            checkedNode: false,
            pageSize: 25,
            gridApiParams: [],
            exportFields: exportData,
            VCCheckBoxInfo: emptyVCCheckBoxData,
            rowGroupPanelShow: 'always',
            groupDefaultExpanded: -1,
            autoGroupColumnDef: { minWidth: 200 },
            IsCommandIssued: false,
            PrevSelectedItems: [],
            customerSuggestions: [], customerIdvalue: '', targetId: '', selectedTreeNodes: [], showEditAssetWindow: false,
            rcdColumns: Columns,
        }

        this.onCheck = this.onCheck.bind(this);
        lastCheckedNodes = [];
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/RcdStatus/GetCustomersTree')
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<treeNodes[]>)
            .then(data => {
                this.setState({
                    //customersSO: data,
                    TreeNodes: data, selectedTreeNodes: data
                });
                //Start RCNG 124
                if (data.length > 0) {
                    $.each(data, function (i, n) {

                        if (customerlst.customerID.indexOf(data[i].value) == -1)
                            customerlst.customerID.push(data[i].value);

                        if (customerlst.customerName.indexOf(data[i].label) == -1)
                            customerlst.customerName.push(data[i].label);
                    });
                }
                //End RCNG 124
            });

        if (this.props.location.state != undefined && this.props.location.state != null) {
            statusFilters = this.props.location.state;
        }
        else if (this.props.rcdSearchFilters != undefined && this.props.rcdSearchFilters != null) {
            statusFilters = this.props.rcdSearchFilters;
        }
        else
            this.ClearFilters();
        $('#globalLoader').show();
        this.props.requestEventMaster();
        this.props.requestRcdAdvanceSearch(statusFilters);
        self = this;
    }

    ClearFilters() {
        var filters: server.RcdStatusSearchFilters = {
            SelectedRcd: null, SelectedCountry: null, SelectedInterval: null, SelectedGeofenceInside: null, SelectedGeofence: null, SelectedICCID: null, SelectedMSISDN: null, AllRcds: null, SelectedAssetType: null
        };

        statusFilters = filters;
    }

    updateRcdStatusDimensions() {
        $("#RcdStatusGrid .ag-root-wrapper-body").css('min-height', $(window).height() - 339);
        $("#RcdStatusGrid .ag-root-wrapper-body").css('height', $(window).height() - 339);
        $("#RcdStatusGrid .ag-root-wrapper-body").css('max-height', $(window).height() - 339);
    }

    //componentWillUnmount() {
    //    window.removeEventListener("resize", this.updateRcdStatusDimensions.bind(this));
    //}

    componentDidMount() {
        var authRight = RCUtils.CheckAssesRightsOnly('6');
        if (!authRight) { this.props.history.push('/AccessDenied'); } else {
            //this.updateRcdStatusDimensions();
            window.addEventListener("resize", this.updateRcdStatusDimensions.bind(this));
            Excel.preventDefault();

            setTimeout(() => { this.updateRcdStatusDimensions() }, 200);
            // To make the Modal popups draggable.
            Excel.draggableModalPopup(document.getElementById("contextMenuModel"));
            Excel.draggableModalPopup(document.getElementById("myAssignedModal"));
            Excel.draggableModalPopup(document.getElementById("myCustModal"));
        }
    }

    onGridReady(params: any) {
        //this.columnApi = params.autoSizeColumns();  
        //params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        self.setState({ gridApiParams: params.api });
        //RCNG-3425
        var refAppParams = self.props.refApplicationParams;
        if (refAppParams != null && refAppParams != undefined) {
            if (refAppParams.EnableLynxCommands != null && refAppParams.EnableLynxCommands != undefined)
                EnableLynxCommands = refAppParams.EnableLynxCommands == 'true' ? true : false;
            if (refAppParams.EnableCT35ML5Commands != null && refAppParams.EnableCT35ML5Commands != undefined)
                EnableCT35ML5Commands = refAppParams.EnableCT35ML5Commands == 'true' ? true : false;
        }

        var rowGroupItems = [];
        rowGroupItems = self.props.SelectedRowGroups;

        if (rowGroupItems != null && rowGroupItems != undefined && rowGroupItems.length > 0
            && self.state.gridApiParams.gridOptionsWrapper != null && self.state.gridApiParams.gridOptionsWrapper != undefined) {
            self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setRowGroupColumns(rowGroupItems);
        }
    }

    onSelectionChanged(params: any) {
        $('#globalLoader').hide();
        //var rights = self.props.loggedInUserData.User.Customer.Rights;
        selectedRowsRcdData = [];
        selectedRowDataIds = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedRowsRcdData.push(selectedRow);
            selectedRowDataIds.push(selectedRow.RCDMasterID);
        });

        //var selectedItems = self.state.selectedItems;
        self.setState({ selectedItems: selectedRowsRcdData });
        //if (self.props.loggedInUserData != null) {
        //var checkIsFO = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd;//self.props.loggedInUserData.IsFO;
        //    if (checkIsFO == "FO") {
        //        $("#liAssignToCustomer").addClass('disabled');
        //        $("#liUnassignFromCustomer").addClass('disabled');
        //    }
        ////}

        //if (selectedRowsRcdData.length > 1) {
        //    $('#liDetailsRequiresRight').removeClass('enabled');
        //    $('#liDetailsRequiresRight').addClass('disabled');
        //}
        //else {
        //    $('#liDetailsRequiresRight').removeClass('disabled');
        //    $('#liDetailsRequiresRight').addClass('enabled');
        //}

        //// showing Selected commands for device Type CT5000
        //var isDeviceTypeFound = 0;
        //var isCT4Found = 0;
        //$.each(selectedRowsRcdData, function (i, val) {
        //    if (val.DeviceType != null && val.DeviceType != undefined) {
        //        if (val.DeviceType.toString().trim() == 'CT5000') {
        //            isDeviceTypeFound = isDeviceTypeFound + 1;
        //        }
        //        if (val.DeviceType.toString().trim() == 'CT4000') {
        //            isCT4Found = isCT4Found + 1;
        //        }
        //    }
        //});

        //var isM2C = 0; var IsDryDevice = 0;
        //$.each(selectedRowsRcdData, function (i, val) {
        //    if (val.DeviceType != null && val.DeviceType != undefined) {
        //        if (val.DeviceType.toString().trim() == 'WG1' || val.DeviceType.toString().trim() == 'WG2' || val.DeviceType.toString().trim() == 'X47' || val.DeviceType.toString().trim() == 'X48') {
        //            isM2C = isM2C + 1;
        //        }
        //        if (val.DeviceType.toString().trim() == 'X47' || val.DeviceType.toString().trim() == 'X48') {
        //            IsDryDevice = IsDryDevice + 1;
        //        }
        //    }
        //});
        //if (IsDryDevice > 0) {
        //    if ($("#liCargoCareTasksRequiresRight").hasClass("show")) $('#liCargoCareTasksRequiresRight').addClass('d-none');
        //}
        //else {
        //    if ($("#liCargoCareTasksRequiresRight").hasClass("show")) $('#liCargoCareTasksRequiresRight').removeClass('d-none');
        //    if (isCT4Found > 0) {
        //        if ($("#liPingRequiresRight").hasClass("show")) $('#liPingRequiresRight').removeClass('d-none');
        //        if ($("#liDeviceResetRequiresRight").hasClass("show")) $('#liDeviceResetRequiresRight').removeClass('d-none');
        //        if ($("#liGetAssetIdRequiresRight").hasClass("show")) $('#liGetAssetIdRequiresRight').removeClass('d-none');

        //        if ($("#liDeviceHardResetRequiresRight").hasClass("show")) $('#liDeviceHardResetRequiresRight').addClass('d-none');
        //        if ($("#liReportingIntervalRequiresRight").hasClass("show")) $('#liReportingIntervalRequiresRight').addClass('d-none');
        //        $('#liassignpanidRequiueresRight').addClass('d-none');
        //        $('#liAutoConfigurationRequiresRight').addClass('d-none');
        //    }
        //    // showing Selected commands for device Type CT5000
        //    else if (isDeviceTypeFound > 0 || isM2C > 0) {
        //        if ($("#liPingRequiresRight").hasClass("show")) $('#liPingRequiresRight').removeClass('d-none');
        //        if ($("#liReportingIntervalRequiresRight").hasClass("show")) $('#liReportingIntervalRequiresRight').addClass('d-none');
        //        if (isDeviceTypeFound > 0)
        //            if ($("#liGetAssetIdRequiresRight").hasClass("show")) $('#liGetAssetIdRequiresRight').removeClass('d-none');
        //        if ($("#liDeviceResetRequiresRight").hasClass("show")) $('#liDeviceResetRequiresRight').addClass('d-none');
        //        if ($("#liDeviceHardResetRequiresRight").hasClass("show")) $('#liDeviceHardResetRequiresRight').addClass('d-none');

        //        $('#liassignpanidRequiueresRight').addClass('d-none');
        //        $('#liAutoConfigurationRequiresRight').addClass('d-none');
        //    }
        //    else {
        //        if ($("#liPingRequiresRight").hasClass("show")) $('#liPingRequiresRight').removeClass('d-none');
        //        if ($("#liReportingIntervalRequiresRight").hasClass("show")) $('#liReportingIntervalRequiresRight').removeClass('d-none');
        //        if ($("#liDeviceResetRequiresRight").hasClass("show")) $('#liDeviceResetRequiresRight').removeClass('d-none');
        //        if ($("#liDeviceHardResetRequiresRight").hasClass("show")) $('#liDeviceHardResetRequiresRight').removeClass('d-none');
        //        if ($("#liGetAssetIdRequiresRight").hasClass("show")) $('#liGetAssetIdRequiresRight').addClass('d-none');

        //        $('#liassignpanidRequiueresRight').removeClass('d-none');
        //        $('#liAutoConfigurationRequiresRight').removeClass('d-none');
        //    }
        //if (isM2C > 0) {
        //    if ($("#liPingRequiresRight").hasClass("show")) $('#liPingRequiresRight').addClass('d-none');
        //    $('#liCargoCareTasksRequiresRight').addClass('d-none');

        //}
        //else {
        //    if ($("#liPingRequiresRight").hasClass("show")) $('#liPingRequiresRight').removeClass('d-none');
        //    $('#liCargoCareTasksRequiresRight').removeClass('d-none');
        //}
        //}
    }

    ExportToExcel() {
        var arrData;
        if (self.state.selectedItems != null) {
            arrData = typeof self.state.selectedItems != 'object' ? JSON.parse(self.state.selectedItems) : self.state.selectedItems;
        }
        else {
            arrData = typeof this.props.rcdStatus != 'object' ? JSON.parse(this.props.rcdStatus) : this.props.rcdStatus;
        }
        $("#globalLoader").show();
        try {
            //Excel.InitializeExportParent(arrData, rcdColumns, 'DeviceStatusGrid');
            //PopupWindow.showErrorMessage("Alert", "Data exported successfully.");
            var formName = 'DeviceStatusGrid';
            ExportAction.ExportSelectedRows(this.state.gridApiParams, formName);

            //var uri = Excel.InitializeExportParentToXLSX(arrData, rcdColumns, formName);
            //this.state.exportFields.ExportData = JSON.stringify(uri);
            //var sheetData = { HeaderData: [], ColumnData: [] };
            //sheetData = Excel.ConvertCSVToJSon(uri);
            //GridToolBarControl.applySheetData(sheetData, formName);
        }
        catch (ex) {
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "Error in data export.");
        }
    }
    getdeviceContextMenuItems = params => {
        if (params != null && params != undefined && params.node != null && params.node != undefined && !params.node.group) {
            if (EnableCT35ML5Commands == undefined) {
                var refAppParams = self.props.refApplicationParams;
                if (refAppParams != null && refAppParams != undefined) {
                    if (refAppParams.EnableLynxCommands != null && refAppParams.EnableLynxCommands != undefined)
                        EnableLynxCommands = refAppParams.EnableLynxCommands == 'true' ? true : false;
                    if (refAppParams.EnableCT35ML5Commands != null && refAppParams.EnableCT35ML5Commands != undefined)
                        EnableCT35ML5Commands = refAppParams.EnableCT35ML5Commands == 'true' ? true : false;
                }
            }
            var selectflag = false;
            var selectedCell = params.api.getFocusedCell();
            var selectedRowIndex = selectedCell.rowIndex;
            var currentRow = params.api.getDisplayedRowAtIndex(selectedRowIndex);
            if (currentRow != null && currentRow != "undefined" && !currentRow.group) {
                var currentRowId = currentRow.id;
                coppiedData = params.value;
                var selectedrowNode = params.api.getRowNode(currentRowId);
                var rcdId = selectedrowNode.data.RCDMasterID;
                params.api.forEachLeafNode((newRowNode, index) => {
                    if ((newRowNode.data.RCDMasterID === rcdId)) {
                        selectedrowNode = newRowNode;
                        return false;
                    }
                });
                $.each(self.state.selectedItems, (index, item) => {
                    if (item.RCDMasterID == selectedrowNode.data.RCDMasterID) {
                        selectflag = true;
                        return false;
                    }
                });
                if (!selectflag)
                    params.api.deselectAll();
                selectedrowNode.setSelected(true);

            }
            var result = [
                {
                    name: 'Copy Cell',
                    action: () => {
                        this.rcdContextMenuClick("Copy");
                    }
                },
                {
                    name: 'Current Details',
                    action: () => {
                        this.rcdContextMenuClick("Details");
                    },
                    cssClasses: UserRights.checkMenuItemVisibilityMultiple('154,156,159,180'),
                    disabled: UserRights.checkMenuItemDisabled(params, 'CurrentDetails'),
                },
                {
                    name: 'History',
                    action: () => {
                        this.rcdContextMenuClick("History");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('48'),
                },
                {
                    name: 'Commands',
                    //cssClasses: UserRights.checkMenuItemVisibilityMultiple('26, 81, 110, 145, 150, 166, 167'),
                    cssClasses: UserRights.checkMenuItemVisibilityForDeviceStatus('26, 81, 110, 145, 150, 166, 167', params, 'Commands'),
                    //disabled: UserRights.checkMenuItemDisabledForCommands(params, 'Commands'),//RCNG-1936
                    disabled: UserRights.checkMenuItemDisabledForRcdCommands(params, 'Commands', EnableLynxCommands, EnableCT35ML5Commands),//RCNG-3215
                    subMenu: [
                        {
                            name: 'Ping / Report',
                            action: () => {
                                this.popUpPing();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultiple('26,166,167'),
                        },
                        {
                            name: 'Set Reporting Interval',
                            action: () => {
                                this.popUpChangeReporting();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityForDeviceStatus('81', params, 'Reporting Interval'),
                        },
                        {
                            name: 'Device Reset',
                            action: () => {
                                this.popUpDeviceReset();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityForDeviceStatus('145', params, 'Device Reset'),
                        },
                        {
                            name: 'Device Reset To Defaults',
                            action: () => {
                                this.popUpDeviceHardReset();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityForDeviceStatus('150', params, 'Device Reset To Defaults'),
                        },
                        {
                            name: 'Get Asset ID',
                            action: () => {
                                this.popUpGetAssetId();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityForDeviceStatus('199', params, 'Get Asset ID'),
                        },
                        {
                            name: 'Assign PAN Id',
                            action: () => {
                                this.popUpAssignPanId();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityForDeviceStatus(null, params, 'Assign PAN Id'),
                        },
                        {
                            name: 'Device Configuration',
                            action: () => {
                                this.popAutoConfiguration();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityForDeviceStatus('110', params, 'Device Configuration'),
                        },
                    ],
                },
                {
                    name: 'Assign to Customer',
                    cssClasses: UserRights.checkMenuItemVisibilityForDeviceStatus('91', params, 'Assign'),
                    subMenu: [
                        {
                            name: 'Assign',
                            action: () => {
                                this.GetAssignRCDsList();
                            },
                        },
                    ],
                },
                {
                    name: 'Edit Asset ID',
                    action: () => {
                        this.EditAssetIDContextMenuClick();
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('258'),
                    disabled: UserRights.checkMenuItemDisabledForDryEditAsset(params),
                },
                'separator',
                {
                    name: 'Export',
                    action: () => {
                        this.ExportToExcel();
                    },
                },
                {
                    name: 'Send Email',
                    action: () => {
                        this.popUpSendEmail();
                    },
                },
            ];
            //RCNG-3232
            var multiselectresult = [
                {
                    name: 'Assign to Customer',
                    cssClasses: UserRights.checkMenuItemVisibilityForDeviceStatus('91', params, 'Assign'),
                    subMenu: [
                        {
                            name: 'Assign',
                            action: () => {
                                this.GetAssignRCDsList();
                            },
                        },
                    ],
                },
                'separator',
                {
                    name: 'Export',
                    action: () => {
                        this.ExportToExcel();
                    },
                },
                {
                    name: 'Send Email',
                    action: () => {
                        this.popUpSendEmail();
                    },
                },
            ];
            return self.state.selectedItems.length > 1 ? multiselectresult : result;
        }
    };
    getContextMenuItems(params: any) {
        $('#globalLoader').hide();
        var flag = false;
        var selected = params.api.getFocusedCell();
        var selectedrowNode = null;// params.api.getRowNode(selected.rowIndex);
        var tempArray = [];// if sort is clicked save in temp array
        params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
            tempArray.push(rowNode);
        });
        var resortitem = tempArray[selected.rowIndex];
        var sortflage = false;
        var rcdId = resortitem.data.RCDMasterID;
        params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
            if ((NewrowNode.data.RCDMasterID === rcdId)) {
                selectedrowNode = NewrowNode;
                return false;
            }
        });
        $.each(self.state.selectedItems, function (index, item) {
            if (item.RCDMasterID == selectedrowNode.data.RCDMasterID) {
                flag = true;
                return false;
            }
        });
        if (!flag)
            params.api.deselectAll();
        params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
        $(".context-menu").show(); $("#contextmenu").show();
        Excel.preventDefault();

        $(".ag-cell").unbind("contextmenu");
        $(".ag-cell").bind('contextmenu', function (e) {
            $("#contextmenu").show();
            var flag = false;
            var selected = params.api.getFocusedCell();
            var selectedrowNode = null;// params.api.getRowNode(selected.rowIndex);
            var tempArray = [];// if sort is clicked save in temp array
            params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
                tempArray.push(rowNode);
            });
            var resortitem = tempArray[selected.rowIndex];
            var sortflage = false;
            var rcdId = resortitem.data.RCDMasterID;
            params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
                if ((NewrowNode.data.RCDMasterID === rcdId)) {
                    selectedrowNode = NewrowNode;
                    return false;
                }
            });
            $.each(self.state.selectedItems, function (index, item) {
                if (item.RCDMasterID == selectedrowNode.data.RCDMasterID) {
                    flag = true;
                    return false;
                }
            });
            if (!flag)
                params.api.deselectAll();
            params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
            var height = $(window).height() - 200;
            var halfheight = ($(window).height()) / 2;
            var top = e.pageY + 5;
            if (height < top) {
                top = (top - halfheight) + 245;
            }
            var left = e.pageX;
            $(".context-menu").css({
                top: top + "px",
                left: left + "px"
            });
            $(".context-menu").show();
            e.preventDefault();
            return false;
        });

        $(document).contextmenu(function () {
            return false;
        });

        $(document).bind('contextmenu click', function () {
            $(".context-menu").hide();
        });

        $('.context-menu').bind('contextmenu', function () {
            return false;
        });
        $('.context-menu').on('click', 'li', function () {
            $(".context-menu").hide();
        });
    }
    createColumnDefs() {
        return [
            {
                headerName: 'Group',
                minWidth: 210,
                hide: true
            },
            //  { headerName: "ALM", field: "R_HighestSeverityLevel", width: 65, cellRenderer: Formatters.runStateFormatter, onCellClicked: this.onCellClickedCopy.bind(this) },
            //  { headerName: "RUN", field: "RunState", width: 65, cellRenderer: Formatters.runStateFormatter, onCellClicked: this.onCellClickedCopy.bind(this) },
            {
                headerName: "PWR", field: "DevicePowerSourceCd", width: 65, valueGetter: (params) => { return Formatters.PwrSorting(params); },
                filterParams: { valueGetter: params => { return Formatters.pwrStateFormatterForFilter(params); } },
                enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                cellRenderer: ReeferCellRenderer.PwrStateFormatter, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "SW", field: "IgnitionOn", width: 65, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                filterParams: { valueGetter: params => { return GensetFormatter.gensetSwitchFormatterImgForFilter(params); } },
                valueGetter: (params) => { return GensetFormatter.gensetSwitchSorting(params); },
                cellRenderer: GensetCellRender.gensetSwitchFormatterImg, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "ENG", field: "GensetRunning", width: 65, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                filterParams: { valueGetter: params => { return GensetFormatter.gensetRunningFormatterForFilter(params); } },
                valueGetter: (params) => { return GensetFormatter.EngineSorting(params); },
                cellRenderer: GensetCellRender.gensetRunningFormatter, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "OEM", field: "ReeferOEMTypeCd", width: 70, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                filterParams: { valueGetter: params => { return ReeferFormatter.oemTypeFormatterForFilter(params); } },
                valueGetter: params => { return ReeferFormatter.OEMTypeValueFormatterFieldName(params); }, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Device ID", field: "RCDID", enableRowGroup: true, cellClass: 'bigInt', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.RCDID); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Last asset ID", field: "AssetNumber", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.AssetNumber); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Asset type", field: "AssetType", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.AssetType); },
                filterParams: { valueGetter: params => { return Formatters.AssetTypeFormatterForFilter(params); } },
                cellRenderer: Formatters.AssetTypeFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Last event", field: "LastEvent", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                cellRenderer: CellRenderer.StringTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            // { headerName: "Alert", field: "Alerts", cellRenderer: CellRenderer.StringTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
            {
                headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "R_EventDTTM", width: 150,
                filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterR_EventDTTMForFilter(params); } },
                valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "R_EventDTTM"); },
                cellRenderer: Formatters.dateTypeFormatter,
                enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Door", field: "DoorOpen", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                filterParams: { valueGetter: params => { return ReeferFormatter.DevicedoorFormatterFilter(params); } },
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return ReeferFormatter.DeviceDoorFormatterSorting(params); },
                cellRenderer: ReeferFormatter.DevicedoorFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Door time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "DoorEventDtm", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterDoorEventDtmForFilter(params); } }, valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "DoorEventDtm"); },
                cellRenderer: Formatters.dateTypeFormatter, width: 170, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Receipt time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "R_ModifiedDTTM", width: 150,
                filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterR_ModifiedDTTMForFilter(params); } },
                valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "R_ModifiedDTTM"); },
                enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                cellRenderer: Formatters.dateTypeFormatter, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "City", field: "City", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.City); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "State", field: "State", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.State); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Country", field: "Country", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.Country); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Zip", field: "Zip", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.Zip); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 100, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Device fence", field: "GeofenceName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.GeofenceName); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Server fence", field: "ServerGeofenceName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ServerGeofenceName); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            //{ headerName: "Region Fence", field: "RegionGeofenceName", cellRenderer: CellRenderer.StringTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
            {
                headerName: "Device Fence ID", field: "Geofence", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.Geofence); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Server fence ID", field: "ServerGeofence", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ServerGeofence); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            //{ headerName: "Region Fence ID", field: "RegionGeofence", cellRenderer: CellRenderer.StringTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
            {
                headerName: "Loc coords", field: "GPSCoords", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.GPSCoordsSorting(params); }, filterParams: { valueGetter: params => { return Formatters.GPSCoordsForFilter(params); } },
                cellRenderer: ReeferCellRenderer.GPSCoordsFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Loc age (h:m:s)", field: "GPSLastLock", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                filterParams: { valueGetter: params => { return Formatters.secondsToTimeConverterFilter(params); } },
                valueGetter: params => { return Formatters.secondsToTimeConverterFilter(params); },
                width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "MCC (country)", field: "CountryName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.CountryName); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "MNC", field: "MNC", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.MNC); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 70, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "LAC", field: "TowerLocalizationAreaCode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.TowerLocalizationAreaCode); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 70, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Tower ID", field: "TowerBaseStationID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.TowerBaseStationID); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "In geofence", field: "IsInsideGeofence", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.YesNoValueSorting(params.data.IsInsideGeofence); },
                width: 90, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Device supply (V)", field: "ReeferACPowerLevel", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return ReeferFormatter.sensorDataSortingFieldName(params, "ReeferACPowerLevel"); },
                cellRenderer: ReeferFormatter.sensorDataValueFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            //{ headerName: "Device pwr source", field: "RCDPowerSourceCd", cellRenderer: Formatters.rcdPowerSourceFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
            {
                headerName: "Device FW ver", field: "RCDFirmwareVersion", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.rcdFirmwareFormatter(params); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Device BL ver", field: "RCDBootloaderVersion", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RCDBootloaderVersion"); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Device mesh FW ver", field: "RCDMeshFirmwareVersion", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RCDMeshFirmwareVersion"); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Device temp ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return ReeferFormatter.TemperatureSortingFieldName(params, "DeviceTemp"); },
                filterParams: { valueGetter: params => { return Formatters.DeviceTempFormatterForFilter(params); } },
                cellRenderer: ReeferFormatter.TemperatureValueFormatter, field: "DeviceTemp", width: 130, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Device bat (V)", field: "BatteryVoltage", enableRowGroup: true, cellClass: 'bigInt', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.BattVoltageSortingFieldName(params, "BatteryVoltage"); },
                filterParams: { valueGetter: params => { return Formatters.BatteryVoltageFormatterForFilter(params); } },
                cellRenderer: Formatters.BattVoltageValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Door bat", field: "DoorSensorBatteryVoltage", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.doorBattPctSorting(params); },
                filterParams: { valueGetter: params => { return Formatters.doorBattPctFormatterFilter(params); } },
                cellRenderer: CellRenderer.battPctFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Geofence revision", field: "RevisionNum", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RevisionNum"); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "MSISDN", field: "MSISDN", enableRowGroup: true, cellClass: 'bigInt', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "MSISDN"); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "IMSI", field: "SIM_IMSI", enableRowGroup: true, cellClass: 'bigInt', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "SIM_IMSI"); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "ICCID", field: "ICCID", enableRowGroup: true, cellClass: 'bigInt', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ICCID"); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "EUI", field: "EUI", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "EUI"); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Cell Signal", field: "RSSI", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.RSSISorting(params); }, filterParams: { valueGetter: params => { return Formatters.RSSITypeFormatterFilter(params); } },
                cellRenderer: ReeferCellRenderer.RSSITypeFormatter, width: 80, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Reporting (min)", field: "RCDReportingInterval", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RCDReportingInterval"); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Assigned to", field: "CustomerName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: params => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSortingFor3P(params.data.CustomerName); },
                filterParams: { valueGetter: params => { return Formatters.stringTypeFormatterFor3PForFilter(params); } },
                cellRenderer: ReeferCellRenderer.StringTypeFormatterFor3P, width: 130, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Device config", field: "DeviceConfig", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                filterParams: { valueGetter: params => { return Formatters.GuestReeferModeFormatterForFilter(params); } },
                cellRenderer: Formatters.GuestReeferModeFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this)
            },
            {
                headerName: "Device type", field: "DeviceType", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.DeviceType); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this)
            }
        ];
    }

    groupRowInnerRenderer(params) {
        var fieldName = params.node.field;
        var fieldValue = params.node.key;

        //var colDef = params.node.columnApi.columnController.rowGroupColumns.filter(x => x.colId == fieldName);
        //var columnDisplayName = colDef[0].colDef.headerName;
        var columnDisplayName = params.node.rowGroupColumn.colDef.headerName;//WI 26719

        if (fieldValue == "-NA-" || fieldValue == "null")
            return "*No " + columnDisplayName;

        if (fieldValue.toString().trim() == "-999" && fieldName.toString().trim() == "BatteryVoltage")
            return "*No " + columnDisplayName;
        if ((fieldValue.toString().trim() == "-999" || fieldValue.toString().trim() == "-1") && fieldName.toString().trim() == "DoorSensorBatteryVoltage")
            return "*No " + columnDisplayName;
        if (fieldValue.toString().trim() == "-999")
            return "OOR";

        switch (fieldName.toString().trim()) {
            case "IgnitionOn":
                return GensetCellRender.GensetSwitchFormatterGrouping(fieldValue);
            case "GensetRunning":
                return GensetCellRender.EngineSortingFormatterGrouping(fieldValue);
            case "DevicePowerSourceCd":
                return ReeferCellRenderer.PowerStateFormatterGrouping(fieldValue);
            case "ReeferOEMTypeCd":
                return Formatters.OEMTypeFormatterGrouping(fieldValue);
            case "AssetType":
                return Formatters.AssetTypeGrouping(fieldValue);
            case "CustomerName":
                return fieldValue == JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName ? "*No Assigned To" : fieldValue;
            case "RSSI":
                return ReeferCellRenderer.RSSIFormatterGrouping(fieldValue);
            case "DeviceConfig":
                return Formatters.GuestReeferModeGrouping(fieldValue);
            case "DeviceTemp":
                {
                    var DeviceType;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        DeviceType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceType;
                    }
                    return Formatters.TemperatureFormatterGrouping(fieldValue, fieldName, params, DeviceType);
                }
            case "R_EventDTTM":
            case "R_ModifiedDTTM":
            case "DoorEventDtm":
                return Formatters.dateTypeGrouping(fieldValue, fieldName, params);
            case "GPSCoords":
                return Formatters.GPSCoordsFormatterGrouping(fieldValue, params);
            case "DoorOpen":
                return Formatters.DeviceDoorFormatterGrouping(fieldValue);
            case "DoorSensorBatteryVoltage":
                {
                    var AssetType;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        AssetType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].AssetType;
                    }
                    if(AssetType != null && AssetType != undefined && AssetType != "")
                        if(AssetType.toString().toUpperCase().trim() == "D")
                            return CellRenderer.DoorBattPctFormatterGrouping(fieldValue);
                }
            default:
                return fieldValue;
        }
    }

    bindingRcdStatusGrid(searchState: server.RcdStatusSearchFilters) {
        $('#globalLoader').show();
        this.setState({
            modelTitle: '',
            popUpHtml: ''
        });
        this.props.requestRcdAdvanceSearch(searchState);
    }

    static refreshDeviceStatusGrid() {
        self.refreshRCDStatusGrid();
    }

    refreshRCDStatusGrid() {
        $('#globalLoader').show();
        this.setState({
            modelTitle: '',
            popUpHtml: ''
        });
        //this.ResetContextMenuItems();
        this.props.requestRcdAdvanceSearch(this.props.rcdSearchFilters);
    }

    AssignCustomer() {
        this.setState({ showAssignToCustomerComponent: true });
        $("#myAssignedModal .close").click();
    }

    CancelAssignToCustomer() {
        this.setState({ showAssignToCustomerComponent: false });
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
    }

    AssignToCustomerConfirm() {
        $('#globalLoader').show();
        var r = this.state.checked;
        var cssClass = "";
        if (r.length > 0) {
            this.state.SelectedCustomer.CustomerID = r[0];
            this.state.SelectedCustomer.SelectedRcdIDs = selectedRowDataIds.toString();
            var filterParams = JSON.stringify(this.state.SelectedCustomer);
            var url = Config.ApiBaseUrl + '/api/RcdStatus/AssignRCDsToCustomerSO';
            var request = RCUtils.FetchRequest(url, { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<string>)
                .then(data => {
                    this.setState({
                        AssignedStatus: data
                    });
                    if (this.state.AssignedStatus == 'Assigned') {
                        this.refreshRCDStatusGrid();
                        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
                        PopupWindow.showErrorMessage("Alert!", "Selected Device(s) have been successfully assigned to the customer.");
                    }
                    else {
                        $('#globalLoader').hide();//RCNG-1655
                        cssClass = $("#assigned").attr('class');
                        $("#assigned").removeClass(cssClass);
                        $("#assigned").addClass('alert alert-danger');
                        $("#assigned").text('Selected Device(s) could not be assigned to the customer.');
                    }
                });

        }
        else {
            $('#globalLoader').hide();
            cssClass = $("#assigned").attr('class');
            $("#assigned").removeClass(cssClass);
            $("#assigned").addClass('alert alert-warning');
            $("#assigned").text('Please select at least one customer for selected Device(s).');

        }
    }

    CancelCustomer() {
        var r = this.state.checked;
        this.setState({ checked: [] });
        lastCheckedNodes = [];
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
    }

    //Start of RCNG 124
    onCustomerChange = (event, { newValue }) => {
        this.setState({
            customerIdvalue: newValue,
            targetId: event.target.id
        });
        var inputValue = newValue.trim().toLowerCase();
        var newNodesData = [];
        var nodesData = this.state.TreeNodes;
        for (let c = 0; c < nodesData.length; c++) {
            if (nodesData[c].label.trim().toLowerCase().includes(inputValue)) {
                newNodesData.push(nodesData[c])
            }
        }
        this.setState({ selectedTreeNodes: newNodesData });
    };

    getSuggestionValue(suggestion) {
        // selectionChanged = true;
        return suggestion;
    }

    renderSuggestion(suggestion) {
        return <span>{suggestion}</span>;
    }

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            customerSuggestions: this.getCustomerSuggestions(value)
        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            customerSuggestions: []
        });
    };

    getCustomerSuggestions(value) {
        // var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : customerlst.customerName.filter(label =>
            //  label.toLowerCase().slice(0, inputLength) === inputValue);
            label.toLowerCase().includes(inputValue));
        //return '';
    };

    //End of RCNG 124

    onCheck(checked) {
        if (lastCheckedNodes.length == 0) {
            lastCheckedNodes = checked;
            this.setState({ checked: checked });
        }
        else {
            var chk = checked.indexOf(lastCheckedNodes[0]);
            if (chk >= 0)
                checked.splice(chk, 1);
            lastCheckedNodes = checked;
            this.setState({ checked: checked });
        }

    }

    GetAssignRCDsList() {
        var cssClass = "";
        SelectedRcds = "";
        cssClass = $("#assigned").attr('class');
        $("#assigned").removeClass(cssClass);
        $("#assigned").text('');
        var url = Config.ApiBaseUrl + '/api/RcdStatus/GetAssignRCDsList?rcdMasterIDs=';
        var request = RCUtils.FetchRequest(url + selectedRowDataIds, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<RCDCustomerIdUI[]>)
            .then(data => {
                if (data.length > 1) {
                    data.forEach(function (value) {
                        SelectedRcds = SelectedRcds == "" ? value.RCDID : SelectedRcds + "," + value.RCDID;
                    });
                }
                else {
                    SelectedRcds = data[0].RCDID;
                }
                this.setState({ isLoading: false, customerIdvalue: '', checked: [], selectedTreeNodes: this.state.TreeNodes });
            });
        $("#btnTriggerAssign").click();
    }

    componentWillReceiveProps(nextprops: any) {
    }

    rcdhistoryAction(data: any) {
        var rcddetails = data;
        this.props.history.push('/rcdhistory', rcddetails);
    }

    reeferrcddetailsAction(data: any, dataSource: any, isOpenVia: any) {

        if (data[0].AssetNumber != null && data[0].AssetNumber != undefined && data[0].AssetNumber != '') {
            //if (data[0].DeviceType.trim() == 'WG1' || data[0].DeviceType.trim() == 'WG2') {
            if (data[0].AssetType.trim() == 'G') {
                var gensetdetails = {
                    gensetData: data[0], source: dataSource, isOpenVia: isOpenVia, isDevice: true
                };
                this.props.history.push('/gensetdetails', gensetdetails);
            }
            // else if (data[0].DeviceType.trim() == 'X47' || data[0].DeviceType.trim() == 'X48' || data[0].DeviceType.trim() == 'GT1200') {
            else if (data[0].AssetType.trim() == 'D') {
                var drydetails = {
                    dryData: data[0], source: dataSource, isOpenVia: isOpenVia, isDevice: true
                };
                this.props.history.push('/drydetails', drydetails);
            }
            //else if (data[0].DeviceType.trim() == 'GT1020') {
            else if (data[0].AssetType.trim() == 'C') {
                var chassisdetails = {
                    chassisData: data[0], source: dataSource, isOpenVia: isOpenVia, isDevice: true
                };
                this.props.history.push('/chassisdetails', chassisdetails);
            }
            //else {
            else if (data[0].AssetType.trim() == 'R') {
                var reeferdetails = {
                    reeferData: data[0], source: dataSource, isOpenVia: isOpenVia, isDevice: true
                };
                this.props.history.push('/reeferdetails', reeferdetails);
            }
        }
    }
    EditAssetIDContextMenuClick(this: any) {
        $("#btnTriggerEditAsset").click();
        this.setState({ showEditAssetWindow: true });
    }
    rcdContextMenuClick(this: any, item: any) {
        switch (item) {
            case "Copy": this.rcddetailsCopyAction();
                break;
            case "History": this.rcdhistoryAction(this.state.selectedItems);
                break;
            case "Details": this.reeferrcddetailsAction(this.state.selectedItems, 'Device', 'RcdStatus');
                break;
        }
    }

    rcddetailsCopyAction() {
        var result = this.copyToClipboard(coppiedData);
    }

    copyToClipboard(text) {
        if ((window as any).clipboardData && (window as any).clipboardData.setData) {
            return (window as any).clipboardData.setData("Text", text);

        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");
            } catch (ex) {
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        }
    }

    onCellClickedCopy(event) {
        coppiedDataWithHeader = event.colDef.headerName + " \r\n" + event.value;
        coppiedData = event.value;
    }

    popUpSendEmail() {
        self.setState({ modelTitle: 'Send Email' });
        self.RenderContextMenuPopUp('SendEmail', false);
    }

    popUpPing() {
        self.setState({ modelTitle: 'Ping' });
        self.RenderContextMenuPopUp('Ping', true);
    }

    popUpChangeReporting() {
        self.setState({ modelTitle: 'Change Reporting Interval' });
        self.RenderContextMenuPopUp('ChangeReportingInterval', true);
    }

    popUpAssignPanId() {
        self.setState({ modelTitle: 'Assign PAN ID' });
        self.RenderContextMenuPopUp('AssignPanId', true);
    }
    popAutoConfiguration() {
        if (self.state.selectedItems.length > 0) {
            var reeferData = self.state.selectedItems;
            var customerIdsCount = 0;

            $.each(reeferData, function (key, value) {
                var customerId = reeferData[0].CustomerID;
                if (value.CustomerID != customerId) {
                    customerIdsCount++;
                }
            });
            if (customerIdsCount > 0) {
                PopupWindow.showErrorMessage("Alert", "Selected Reefer(s) should be of same customer.");
            }
            else {
                self.setState({ modelTitle: 'Device Configuration' });
                self.RenderContextMenuPopUp('AutoConfig', false);
            }
        }
    }
    popUpUnAssignDeviceFromCustomer() {
        self.setState({ modelTitle: 'Unassign Units From Customer' });
        self.RenderContextMenuPopUp('UnAssignCustomer', false);
    }

    popUpDeviceReset() {
        self.setState({ modelTitle: 'Device Reset' });
        self.RenderContextMenuPopUp('DeviceReset', true);
    }

    popUpDeviceHardReset() {
        self.setState({ modelTitle: 'Device Reset To Defaults' });
        self.RenderContextMenuPopUp('DeviceHardReset', true);
    }

    popUpGetAssetId() {
        self.setState({ modelTitle: 'Get Asset ID' });
        self.RenderContextMenuPopUp('GetAssetId', true);
    }
    UpdateIsCommandIssued(IsCmdIssued: any) {
        self.setState({ IsCommandIssued: IsCmdIssued });
    }
    UpdatePrevSelectedItems(prevSelectedItems: any) {
        self.setState({ PrevSelectedItems: prevSelectedItems });
    }
    ComponentRenderingForCommands(popUpName: string, userData: any) {
        switch (popUpName) {
            case 'SendEmail':
                return <SendEmailControl reeferStatusResult={self.state.selectedItems} gridApiParams={this.state.gridApiParams} columnDefinition={this.createColumnDefs()} parentchild={"S"} formname={"DeviceStatusGrid"} />;
            case 'Ping':
                if (self.state.selectedItems[0].DeviceType.toString().trim() == 'WG1' || self.state.selectedItems[0].DeviceType.toString().trim() == 'WG2' || self.state.selectedItems[0].DeviceType.toString().trim() == 'X47' || self.state.selectedItems[0].DeviceType.toString().trim() == 'X48')
                    return <DevicePingControlForM2C reeferData={self.state.selectedItems} refreshRCDStatusGrid={this.refreshRCDStatusGrid.bind(this)} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)}></DevicePingControlForM2C>;
                else
                    return <DevicePingControl reeferData={self.state.selectedItems} refreshRCDStatusGrid={this.refreshRCDStatusGrid.bind(this)} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)}></DevicePingControl>;
            case 'ChangeReportingInterval':
                return <DeviceChangeReportingInterval reeferData={self.state.selectedItems} refreshRCDStatusGrid={this.refreshRCDStatusGrid.bind(this)} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)}></DeviceChangeReportingInterval>;
            case 'AssignPanId':
                return <DeviceAssignPANID reeferData={self.state.selectedItems} refreshRCDStatusGrid={this.refreshRCDStatusGrid.bind(this)} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)}></DeviceAssignPANID>;
            case 'UnAssignCustomer':
                return <DeviceUnassignFromCustomer reeferData={self.state.selectedItems} refreshRCDStatusGrid={this.refreshRCDStatusGrid.bind(this)}></DeviceUnassignFromCustomer>;
            case 'AutoConfig':
                return <AutoConfiguration reeferData={self.state.selectedItems} autoConfig={true} refreshGrid={"Devicestatus"} refreshRCDStatusGrid={this.refreshRCDStatusGrid.bind(this)} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></AutoConfiguration>;
            case 'DeviceReset':
                return <DeviceResetDeviceStatus reeferData={self.state.selectedItems} refreshRCDStatusGrid={this.refreshRCDStatusGrid.bind(this)} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)}></DeviceResetDeviceStatus>;
            case 'DeviceHardReset':
                return <DeviceHardResetDeviceStatus reeferData={self.state.selectedItems} refreshRCDStatusGrid={this.refreshRCDStatusGrid.bind(this)} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)}></DeviceHardResetDeviceStatus>;
            case 'GetAssetId':
                return <GetAssetId reeferData={self.state.selectedItems} refreshRCDStatusGrid={this.refreshRCDStatusGrid.bind(this)} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)}></GetAssetId>;
        }
    }

    RenderContextMenuPopUp(popUpName: string, isCommands: boolean) {
        var rcdData = self.state.selectedItems;
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        var userData = JSON.parse(sessionStorage.getItem('UserInfo'));
        var filterSet: server.USP_RcdCurrentConditionUI[];
        filterSet = rcdData;
        var filterParams = JSON.stringify(filterSet);
        var checkBoxInfo = this.state.VCCheckBoxInfo;
        if (isCommands) {
            if (rcdData != undefined && rcdData != null) {
                if (popUpName == "GetDLTraditional" || popUpName == "SchedulePreTrip") {
                    checkBoxInfo.disableVCOption = true;
                    checkBoxInfo.enableVCCheckBox = false;
                    checkBoxInfo.disableVCCheckBoxOption = true;
                    checkBoxInfo.disableVCDropDown = true;
                    checkBoxInfo.selectedVCData = null;
                    self.setState({ VCCheckBoxInfo: checkBoxInfo });
                    self.setState({ popUpHtml: self.ComponentRenderingForCommands(popUpName, userData, checkBoxInfo) });
                    $('#btnTrigger').click();
                }
                else {
                    $('#globalLoader').show();
                    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/CheckIsMsgFromVesselRCD', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            var vesselid = data;
                            var url = Config.ApiBaseUrl + '/api/reeferstatus/GetVesselInformation?customerID=' + custId;
                            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                            fetch(request)
                                .then(RCUtils.handleError)
                                .then(response => response.json() as Promise<server.VesselInformation[]>)
                                .then(result => {
                                    checkBoxInfo.dropDownVCData = result;
                                    if (result.length > 0) {
                                        if (vesselid == "-1") {
                                            checkBoxInfo.disableVCOption = false;
                                            checkBoxInfo.enableVCCheckBox = false;
                                            checkBoxInfo.disableVCCheckBoxOption = true;
                                            checkBoxInfo.disableVCDropDown = true;
                                            checkBoxInfo.selectedVCData = null;
                                            checkBoxInfo.isVCMessage = true;
                                        }
                                        else if (vesselid == "0") {
                                            checkBoxInfo.disableVCOption = false;
                                            checkBoxInfo.enableVCCheckBox = false;
                                            checkBoxInfo.disableVCCheckBoxOption = false;
                                            checkBoxInfo.disableVCDropDown = true;
                                            checkBoxInfo.selectedVCData = null;
                                            checkBoxInfo.isVCMessage = false;
                                        }
                                        else {
                                            checkBoxInfo.disableVCOption = false;
                                            checkBoxInfo.enableVCCheckBox = true;
                                            checkBoxInfo.disableVCCheckBoxOption = false;
                                            checkBoxInfo.disableVCDropDown = false;
                                            checkBoxInfo.selectedVCData = checkBoxInfo.dropDownVCData.find(d => d.VesselId == parseInt(vesselid));
                                            checkBoxInfo.isVCMessage = true;
                                        }
                                    }
                                    else {
                                        checkBoxInfo.disableVCOption = true;
                                        checkBoxInfo.enableVCCheckBox = false;
                                        checkBoxInfo.disableVCCheckBoxOption = true;
                                        checkBoxInfo.disableVCDropDown = true;
                                        checkBoxInfo.selectedVCData = null;
                                    }
                                    self.setState({ VCCheckBoxInfo: checkBoxInfo });
                                    $('#globalLoader').hide();
                                    self.setState({ popUpHtml: self.ComponentRenderingForCommands(popUpName, userData) });
                                    $('#btnTrigger').click();
                                });
                        });
                }
            }
        }
        else {
            checkBoxInfo.disableVCOption = true;
            checkBoxInfo.enableVCCheckBox = false;
            checkBoxInfo.disableVCCheckBoxOption = true;
            checkBoxInfo.disableVCDropDown = true;
            checkBoxInfo.selectedVCData = null;
            self.setState({ VCCheckBoxInfo: checkBoxInfo });
            self.setState({ popUpHtml: self.ComponentRenderingForCommands(popUpName, userData) });
            $('#btnTrigger').click();
        }
    }

    UpdateVCCheckBoxInfo(VCInfo: any) {
        self.setState({ VCCheckBoxInfo: VCInfo });
    }

    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;
        this.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        self.state.gridApiParams.paginationGoToFirstPage();
    }

    onGridScroll(params: any) {
        $(".context-menu").hide();
        $("#contextmenu").hide();
    }

    requestToHoldRowGroups(params) {

        if (!params.columnApi) return;
        var currentGropup = params.columnApi.getRowGroupColumns().map(c => c.colId);

        var rowGroupItems: any;
        rowGroupItems = currentGropup;

        if (this.props.rcdStatus != undefined && this.props.rcdStatus != null && this.props.rcdStatus.length > 0) {
            this.props.requestToHoldSelectedRowGroups(rowGroupItems);
        }

        if (this.props.rcdStatus != undefined && this.props.rcdStatus != null && this.props.rcdStatus.length === 0
            && self.state.gridApiParams.gridOptionsWrapper != null && self.state.gridApiParams.gridOptionsWrapper != undefined) {
            self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setRowGroupColumns([]);
        }        

    }
    onFirstDataRendered(params) {       
        this.setPrefenceSettingsColumnsWithPreference(params);

    }
    setPrefenceSettingsColumnsWithPreference(params) {       
        var rowGroupItems = [];
        rowGroupItems = this.props.SelectedRowGroups;

        if (rowGroupItems != null && rowGroupItems != undefined && rowGroupItems.length > 0
            && self.state.gridApiParams.gridOptionsWrapper != null && self.state.gridApiParams.gridOptionsWrapper != undefined) {
            self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setRowGroupColumns(rowGroupItems);
        }

    }
    
    public render() {
        var groupRowRendererParams: any = {
            innerRenderer: this.groupRowInnerRenderer
        };
        // start of RCNG 124

        const { customerSuggestions } = this.state;
        const CustomerIdinputProps = {
            id: 'CustomerID',
            placeholder: 'Search customer',
            value: this.state.customerIdvalue,
            onChange: this.onCustomerChange.bind(this)
        };
        //end of RCNG 124
        var excelStyles: any = [
            {
                id: 'bigInt',
                dataType: 'string',
                font: {
                    size: 12
                },

            },
            {
                id: 'myExcelStyle',
                font: {
                    size: 12,
                }
            },
            {
                id: 'header',
                font: {
                    size: 14,
                },
            },
            {
                id: 'OneDecimal',
                numberFormat: {
                    format: '0.0',
                },
                font: {
                    size: 12,
                }
            },
        ];

        return <div>
            <div className="innerpages-heading">
                Device Status
            </div>
            <div>
                <RcdAdvanceSearch bindingRcdStatusGrid={this.bindingRcdStatusGrid.bind(this)} stateData={statusFilters}></RcdAdvanceSearch>
            </div>

            <div>
                <GridToolBarControl refreshGrid={this.refreshRCDStatusGrid.bind(this)} gridData={this.props.rcdStatus} colDefs={this.createColumnDefs()}
                    isIncludeRowGroup={this.state.gridApiParams.gridOptionsWrapper == undefined
                        && this.state.gridApiParams.gridOptionsWrapper == null ? false :
                        this.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false}
                    gridApiParams={this.state.gridApiParams} parentchild={"P"} formName={"DeviceStatusGrid"} />
            </div>
            <div>

                <div className="ag-theme-fresh" id="RcdStatusGrid">
                    <AgGridReact
                        columnDefs={this.state.rcdColumns}
                        rowData={this.props.rcdStatus}
                        onGridReady={this.onGridReady}
                        animateRows={true}
                        rowGroupPanelShow={this.state.rowGroupPanelShow}
                        autoGroupColumnDef={this.state.autoGroupColumnDef}
                        suppressDragLeaveHidesColumns={true}
                        suppressMakeColumnVisibleAfterUnGroup={true}
                        excelStyles={excelStyles}
                        groupRowRendererParams={groupRowRendererParams}
                        //groupRowInnerRenderer={this.groupRowInnerRenderer}
                        defaultGroupOrderComparator={
                            function (nodeA, nodeB) {
                                var AnodeIsNumber = Number(nodeA.key);
                                var BnodeIsNumber = Number(nodeB.key);
                                var AnodeIsString = String(nodeA.key);
                                var BnodeIsString = String(nodeB.key);

                                if (!isNaN(AnodeIsNumber) && !isNaN(BnodeIsNumber)) {
                                    return AnodeIsNumber - BnodeIsNumber;
                                } else {
                                    return AnodeIsString.localeCompare(BnodeIsString);
                                }
                            }
                        }
                        groupDisplayType='groupRows'
                        pagination={true}
                        rowSelection={customerTypeCd == 'SO' ? 'multiple' : 'single'}
                        accentedSort={true}
                        rowDeselection={true}
                        onSelectionChanged={this.onSelectionChanged}
                        allowContextMenuWithControlKey={true}
                        getContextMenuItems={this.getdeviceContextMenuItems}
                        paginationPageSize={this.state.pageSize}
                        onBodyScroll={this.onGridScroll}
                        onColumnRowGroupChanged={this.requestToHoldRowGroups.bind(this)}
                        onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                        onColumnEverythingChanged={this.setPrefenceSettingsColumnsWithPreference.bind(this)}
                    >
                    </AgGridReact>
                </div>
                <div className='pageSize'>
                    <span className='pageSize-lable'>Page Size:</span>
                    <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="75">75</option>
                        <option value="100">100</option>
                        <option value="250">250</option>
                    </select>
                </div>

            </div>
            <div className="row" id='contextmenu'>
                <button id="btnTrigger" data-bs-toggle="modal" className='d-none' data-bs-target="#contextMenuModel" />
                <div className='context-menu'>
                    <ul>
                        <li id="liCopyRequiresRight" onClick={this.rcdContextMenuClick.bind(this, "Copy")}>Copy</li>
                        <li id="liDetailsRequiresRight" className={UserRights.checkVisibilityMultiple('154,156,159,180')} onClick={this.rcdContextMenuClick.bind(this, "Details")}>Current Details</li>
                        <li className={UserRights.checkVisibility('48')} onClick={this.rcdContextMenuClick.bind(this, "History")}>History</li>
                        <li id="liCargoCareTasksRequiresRight" className={'dropdown-submenu ' + UserRights.checkVisibilityMultiple('26, 81, 110, 145, 150, 166, 167')}>
                            <a className='dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Commands</a>
                            <ul className='dropdown-menu'>
                                <li id="liPingRequiresRight" className={UserRights.checkVisibility('26,166,167')} data-bs-toggle="modal" data-bs-target="#contextMenuModel" onClick={this.popUpPing.bind(this)}> Ping / Report</li>
                                <li id="liReportingIntervalRequiresRight" className={UserRights.checkVisibility('81')} data-bs-toggle="modal" onClick={this.popUpChangeReporting.bind(this)}>Set Reporting Interval</li>
                                <li id="liDeviceResetRequiresRight" className={UserRights.checkVisibility('145')} data-bs-toggle="modal" data-bs-backdrop="static" onClick={this.popUpDeviceReset.bind(this)}>Device Reset</li>
                                <li id="liDeviceHardResetRequiresRight" className={UserRights.checkVisibility('150')} data-bs-toggle="modal" data-bs-backdrop="static" onClick={this.popUpDeviceHardReset.bind(this)}>Device Reset To Defaults</li>
                                <li id="liGetAssetIdRequiresRight" className={UserRights.checkVisibility('145')} data-bs-toggle="modal" data-bs-backdrop="static" onClick={this.popUpGetAssetId.bind(this)}>Get Asset ID</li>
                                {customerTypeCd == "SO" ? <div>
                                    <li id="liassignpanidRequiueresRight" data-bs-toggle="modal" data-bs-backdrop="static" onClick={this.popUpAssignPanId.bind(this)}>Assign PAN Id</li>
                                    <li id="liAutoConfigurationRequiresRight" className={UserRights.checkVisibility('110')} data-bs-toggle="modal" data-bs-backdrop="static" onClick={this.popAutoConfiguration.bind(this)}>Device Configuration</li>
                                </div> : <div></div>}
                            </ul>
                        </li>
                        {customerTypeCd == "SO" ?
                            <div>
                                <li id="liThirdPartyAccessRequiresRight" className={'dropdown-submenu ' + UserRights.checkVisibility('91')}>
                                    <a className='dropdown-toggle' data-bs-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Assign to Customer</a>
                                    <ul className='dropdown-menu'>
                                        <li id="liAssignToCustomer" className={UserRights.checkVisibility('91')} data-bs-toggle="modal" data-bs-target="#myAssignedModal" onClick={this.GetAssignRCDsList.bind(this)}>Assign</li>
                                    </ul>
                                </li>
                            </div> : <div></div>
                        }
                        <li onClick={this.ExportToExcel.bind(this)}>Export to Excel</li>
                        <li data-bs-toggle="modal" onClick={this.popUpSendEmail}>Send Email</li>
                    </ul>
                </div>
            </div>
            <div className="modal fade" id="contextMenuModel" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header" id="contextMenuModelHeader">
                            <h5 className="modal-title">{this.state.modelTitle}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" >&times;</button>
                        </div>
                        <div className="modal-body">
                            {this.state.popUpHtml}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="modal fade" id="myCustModal" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header" id="myCustModalHeader">
                                <h5 className="modal-title">Assign Customer</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>

                            </div>
                            <div className='input-group AssignAutoSuggest'>
                                <Autosuggest name="userId" id="userId"
                                    suggestions={customerSuggestions}
                                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                    getSuggestionValue={this.getSuggestionValue}
                                    renderSuggestion={this.renderSuggestion}
                                    inputProps={CustomerIdinputProps}
                                    highlightFirstSuggestion={true}
                                />
                            </div>
                            <div className="modal-body" id="modelbodyHeight">
                                {this.state.showAssignToCustomerComponent == true ?
                                    <CheckboxTree
                                        nodes={this.state.selectedTreeNodes}
                                        checked={this.state.checked}
                                        onCheck={this.onCheck} /> : null}
                            </div>
                            <div className="modal-footer" id='alert-footer-rcdstatus'>
                                <div id="assigned" >
                                </div>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.CancelCustomer.bind(this)}>Cancel</button>
                                <button type="button" className="btn btn-primary" onClick={this.AssignToCustomerConfirm.bind(this)}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <button id="btnTriggerAssign" data-bs-toggle="modal" className='d-none' data-bs-target="#myAssignedModal" />
                <div className="modal fade" id="myAssignedModal" role="dialog" >
                    <div className="modal-dialog" >
                        <div className="modal-content">
                            <div className="modal-header" id="myAssignedModalHeader">
                                <h5 className="modal-title">Assign Units to Customer</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>
                            </div>
                            <div className="modal-body">
                                <div className="alert alert-info" >
                                    {this.state.isLoading ? <div id='divIsLoading'>Loading...</div> :
                                        <div><span className='fa-sharp fa-solid fa-circle-question fa-lg'></span> Selected Device(s) already assigned to a customer.<br /> Do you want to reassign to a new customer?
                                            Device(s):{SelectedRcds}
                                        </div>}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.CancelAssignToCustomer.bind(this)}>No</button>
                                <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#myCustModal" onClick={this.AssignCustomer.bind(this)} >Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <button id="btnTriggerEditAsset" data-bs-toggle="modal" className='d-none' data-bs-target="#EditAsset" />
                <div className="modal fade" id="EditAsset" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Asset ID</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>

                            </div>
                            <div className="modal-body">
                                {this.state.showEditAssetWindow == true ? <EditAsset refData={self.state.selectedItems} refreshRCDStatusGrid={this.refreshRCDStatusGrid.bind(this)} ></EditAsset> : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

export default connect(
    (state: ApplicationState) => ({ ...state.userDetails, ...state.rcdStatus }), // Selects which state properties are merged into the component's props
    RcdStatusState.actionCreators                 // Selects which action creators are merged into the component's props
)(RcdStatus as any);
